export function splitName(name: string): { firstName: string; lastName: string } {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return {
    firstName: parts[0] ?? "?",
    lastName: parts.length > 1 ? parts[parts.length - 1]! : "",
  };
}
